import { useEffect } from "react";
import { ToggleButton, DecimalInput } from "components";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { useInput } from "hooks";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveTradeInSavingsTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const isUpTo = useInput(false);
  const type = useInput("$");
  const val = useInput("10.00");
  const suffix = useInput("or more");

  const typeData = [
    { label: "$", value: "$" },
    { label: "%", value: "%" },
    { label: "X", value: "X" },
  ];
  const suffixData = [
    { label: "or more", value: "or more" },
    { label: "or less", value: "or less" },
  ];

  const handleUpdateValue = (isUT, v, t, s) => {
    onChange(
      `${isUT ? "Up To " : ""}${t === "$" ? `${t}${formatDollarValue(v)}` : `${v}${t}`
      } ${s} trade in savings`
    );
  };

  useEffect(() => {
    if (value.endsWith("trade in savings")) {
      let main = value.slice(0, -16).trim();
      if (main.startsWith("Up To")) {
        isUpTo.setValue(true);
        main = main.slice(5).trim();
      } else {
        isUpTo.setValue(false);
      }
      const sufIndex = main.indexOf(" ");
      const tv = main.slice(0, sufIndex).trim();
      suffix.setValue(main.slice(sufIndex).trim());
      if (tv.startsWith("$")) {
        type.setValue("$");
        val.setValue(tv.slice(1));
      } else {
        type.setValue(tv.slice(-1).trim());
        val.setValue(tv.slice(0, -1).trim());
      }
    }
    return () => { };
  }, [value]);

  return (
    <div className="p-2 d-flex justify-content-between align-items-center">
      <ToggleButton className="mt-3 mr-2" label="Up To"
        value={isUpTo.value} style={{ width: '45%' }}
        onChange={(e) => {
          isUpTo.setValue(e);
          handleUpdateValue(e, val.value, type.value, suffix.value);
        }}
      />

      {type.value === "$" ? (
        <DecimalInput labeled label="Value" placeholder="Value" style={{ width: '96%' }}
          value={val.value}
          onChange={(e) => {
            val.setValue(e);
            handleUpdateValue(isUpTo.value, e, type.value, suffix.value);
          }}
        />
      ) : (
        <LabelledInput label="Value" placeholder="Value" style={{ width: '96%' }}
          allowclear="true" inputType="float" value={val.value}
          onChange={(e) => {
            val.setValue(e);
            handleUpdateValue(isUpTo.value, e, type.value, suffix.value);
          }}
        />
      )}

      <LabelledSelect label="Type" style={{ width: '90%' }}
        options={typeData} value={type.value}
        onChange={(e) => {
          type.setValue(e);
          handleUpdateValue(isUpTo.value, val.value, e, suffix.value);
        }} />

      <LabelledSelect label="Suffix"
        options={suffixData} value={suffix.value}
        onChange={(e) => {
          suffix.setValue(e);
          handleUpdateValue(isUpTo.value, val.value, type.value, e);
        }} />

      <div className="mt-3 ml-2" style={{ fontSize: 12 }}>
        Trade In Savings
      </div>
    </div>
  );
};